import { httpApi } from '@api/http.api.ts';
import type { CommonSearchRequest, PaginatedResponse } from '@types';

export interface UserImportedLearning {
    id: number;
    employeeId: string;
    sourceSystem: string;
    sourceUserId: string;
    type: string;
    title: string;
    completedDateUTC: string | null;
    sourceRank: string | null;
    isRequired: boolean;
    completionPercent: number | null;
    score: number | null;
    learningTimeMinutes: number | null;
    importedOnUTC: string;
    importedByName: string;
    importedByEmail: string;
}

export interface ImportedLearningsFiltersValues {
    employeeIds: string[];
    sourceSystems: string[];
    sourceUserIds: string[];
    types: string[];
    sourceRanks: string[];
    importedOnDates: string[];
    importedBy: string[];
}

export type ImportedLearningsRequest = CommonSearchRequest;

export const getMyImportedLearningResults = (
    payload: ImportedLearningsRequest,
): Promise<PaginatedResponse<UserImportedLearning, ImportedLearningsFiltersValues>> =>
    httpApi
        .post<
            PaginatedResponse<UserImportedLearning, ImportedLearningsFiltersValues>
        >(`learning/imported-results/search`, { ...payload })
        .then(({ data }) => data);
